import { render, staticRenderFns } from "./VerPrazosExames.vue?vue&type=template&id=bc5685fc&"
import script from "./VerPrazosExames.vue?vue&type=script&lang=js&"
export * from "./VerPrazosExames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports